import { render, staticRenderFns } from "./AppNavBar.vue?vue&type=template&id=2a5a536f&"
import script from "./AppNavBar.vue?vue&type=script&lang=js&"
export * from "./AppNavBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports